var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 106,
    viewBox: "0 0 152 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3221 64.8291C29.0672 65.9566 27.6587 66.5203 22.5847 70.1845C17.5108 73.8487 3.77983 86.0069 6.82969 89.6332C6.82969 91.0425 13.2819 97.5253 36.6766 87.3782C33.5761 76.6674 33.2942 75.5399 32.4487 71.312L31.3221 64.8291Z",
    fill: "#D2F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.423 18.2535C134.767 14.0928 96.716 32.9777 103.764 31.5685C98.1258 36.3601 98.9912 37.4203 98.9912 37.4203L102.935 39.1115L106.319 38.2659L106.58 38.0513L107.708 42.843L109.117 50.1715C119.264 47.3529 135.332 32.4141 135.332 32.4141C135.332 32.4141 146.079 22.4142 140.423 18.2535Z",
    fill: "#D2F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.599 91.5713C32.599 91.5713 17.2906 97.6282 7.49756 96.5579",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2961 62.1768C25.2961 62.1768 4.82484 76.0704 1.44434 87.4748",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5922 99.0557C45.5922 99.0557 27.436 105.469 17.8232 104.936",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0308 36.8789L29.7905 40.5267C27.2752 41.2763 25.7852 43.8698 26.41 46.4233L37.5809 92.2852L48.6196 89.2548L38.1256 48.2111C37.4727 45.6577 38.9427 43.0401 41.462 42.2704L48.6196 40.0817",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.472 78.0312L49.5083 93.1756L48.6191 89.2552",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.84 70.3699L105.051 32.4209",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6313 51.3975L40.2399 26.5096C38.7039 24.1776 39.3758 21.0396 41.7318 19.5407L66.9197 3.51747C69.215 2.0573 72.2566 2.70016 73.7647 4.96423L83.8676 20.1307",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1291 36.5939L53.9512 37.2155C53.0105 37.712 51.8458 37.3853 51.3005 36.4721L44.4405 24.9837C43.891 24.0635 44.1646 22.8738 45.0608 22.286L68.1212 7.16076C69.0491 6.55214 70.2951 6.81534 70.8976 7.74722L79.5936 21.197",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5254 18.5273V22.4477L56.4507 20.4875V25.1174L50.5789 23.6944V29.5709",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4785 17.457L52.9084 28.7451L59.313 51.3975L100.047 40.5463L93.4785 17.457Z",
    fill: "#0CD6D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2402 56.4766L106.472 38.835",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.729 12.8274C115.729 12.8274 134.422 7.48402 144.035 10.6909C144.035 10.6909 149.017 13.1842 144.035 20.6682",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.997 34.4258C132.997 34.4258 120.06 45.6778 117.333 46.8523",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.127 21.7344C148.127 21.7344 157.027 26.5887 143.497 40.6428C129.967 54.6968 121.424 58.6131 121.424 58.6131",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4707 9.66464L80.663 0L111.28 9.66464L103.093 39.7369L100.049 40.5466L93.48 17.4573L83.8672 20.131L77.4707 9.66464Z",
    fill: "#121212"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8256 53.623L53.783 62.1773",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.155 66.5498L56.0488 70.3709",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55649 91.5929L2.97827 89.6182L0.999943 94.1882L5.57817 96.1629L7.55649 91.5929Z",
    fill: "#0DC9C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2175_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.981 28.3661C142.741 24.7396 141.769 21.4749 139.81 21.0742C137.85 20.6734 135.645 23.2885 134.884 26.915C134.123 30.5416 135.095 33.8063 137.055 34.207C139.015 34.6077 141.22 31.9926 141.981 28.3661Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.075 27.9786C140.836 24.3521 140.29 21.1745 138.856 20.8814C137.422 20.5882 135.644 23.2904 134.883 26.917C134.122 30.5435 134.668 33.721 136.102 34.0142C137.535 34.3074 139.314 31.6051 140.075 27.9786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.244 25.9566C137.177 26.2693 137.277 26.6096 137.447 26.8785C137.694 27.2763 137.93 27.9622 137.93 28.4287C137.93 29.1613 137.93 29.5866 137.202 29.9542L137.189 30.6676H136.652V29.8554C136.605 29.9185 135.938 28.9226 136.091 28.4726C136.169 28.2421 136.424 27.943 136.563 28.3601C136.749 28.9088 136.694 29.0021 137.044 29.0021C137.394 29.0021 137.286 27.9129 137.016 27.5068C136.747 27.1007 136.569 26.198 136.652 25.7919C136.736 25.3859 136.919 25.1499 137.227 25.1087C137.536 25.0676 137.55 25.1691 137.55 25.1691L137.569 24.6094L137.939 24.7713L137.925 25.4106C137.925 25.4106 138.161 25.5477 138.295 25.9703C138.378 26.2309 138.295 26.6013 138.295 26.6013L137.842 26.6425C137.842 26.6425 137.75 26.2584 137.75 26.2556C137.703 26.0636 137.336 25.4984 137.241 25.9538L137.244 25.9566Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 62C99.866 62 103 58.866 103 55C103 51.134 99.866 48 96 48C92.134 48 89 51.134 89 55C89 58.866 92.134 62 96 62ZM96.525 50.8C96.525 50.5101 96.2899 50.275 96 50.275C95.7101 50.275 95.475 50.5101 95.475 50.8V51.0217C94.3337 51.2261 93.375 52.0835 93.375 53.25C93.375 54.592 94.6439 55.525 96 55.525C96.9635 55.525 97.575 56.159 97.575 56.75C97.575 57.341 96.9635 57.975 96 57.975C95.0365 57.975 94.425 57.341 94.425 56.75C94.425 56.4601 94.1899 56.225 93.9 56.225C93.6101 56.225 93.375 56.4601 93.375 56.75C93.375 57.9165 94.3337 58.7739 95.475 58.9783V59.2C95.475 59.4899 95.7101 59.725 96 59.725C96.2899 59.725 96.525 59.4899 96.525 59.2V58.9783C97.6663 58.7739 98.625 57.9165 98.625 56.75C98.625 55.408 97.3561 54.475 96 54.475C95.0365 54.475 94.425 53.841 94.425 53.25C94.425 52.659 95.0365 52.025 96 52.025C96.9635 52.025 97.575 52.659 97.575 53.25C97.575 53.5399 97.8101 53.775 98.1 53.775C98.3899 53.775 98.625 53.5399 98.625 53.25C98.625 52.0835 97.6663 51.2261 96.525 51.0217V50.8Z",
    fill: "#FFBF5F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2175_4204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.89219,
    height: 13.5295,
    fill: "white",
    transform: "translate(134.485 20.8584)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDep);
export default __webpack_public_path__ + "static/media/dep.b2a30cde88fee4da0070d8b083814847.svg";
export { ForwardRef as ReactComponent };